import { render, staticRenderFns } from "./StepPeopleInvolved.vue?vue&type=template&id=0eb0c7e0&"
import script from "./StepPeopleInvolved.vue?vue&type=script&lang=ts&"
export * from "./StepPeopleInvolved.vue?vue&type=script&lang=ts&"
import style0 from "./StepPeopleInvolved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb0c7e0')) {
      api.createRecord('0eb0c7e0', component.options)
    } else {
      api.reload('0eb0c7e0', component.options)
    }
    module.hot.accept("./StepPeopleInvolved.vue?vue&type=template&id=0eb0c7e0&", function () {
      api.rerender('0eb0c7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/tickets-form/access/StepPeopleInvolved.vue"
export default component.exports